import React from 'react';
import { Card, Typography, Alert, Button } from 'antd';

const { Text, Title } = Typography;

const formatarPercentual = (valor) => valor.toLocaleString('pt-BR', {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

const ResponsavelFrequenciaCard = ({ item, onVerDetalhes }) => {
  const {
    matricula_id: matriculaId,
    aluno_nome: alunoNome,
    turma_nome: turmaNome,
    periodo_inicio: periodoInicio,
    periodo_fim: periodoFim,
    total_aulas_realizadas: totalAulasRealizadas,
    total_presentes: totalPresentes,
    total_ausentes: totalAusentes,
    total_justificadas: totalJustificadas,
    total_nao_informadas: totalNaoInformadas,
    percentual,
    percentual_provisorio: percentualProvisorio,
  } = item;

  return (
    <Card className="responsavel-frequencia-card" role="group" aria-label={`Frequência de ${turmaNome || alunoNome}`}>
      <Title level={5} className="responsavel-frequencia-card__turma">
        {turmaNome || 'Turma não informada'}
      </Title>
      <Text type="secondary" className="responsavel-frequencia-card__periodo">
        {periodoInicio} a {periodoFim}
      </Text>

      <div className="responsavel-frequencia-card__percentual">
        {percentual === null || percentual === undefined ? (
          <Text type="secondary">Sem aulas realizadas no período</Text>
        ) : (
          <Text strong className="responsavel-frequencia-card__percentual-valor">
            {formatarPercentual(percentual)}%
          </Text>
        )}
      </div>

      {percentualProvisorio && (
        <Alert
          type="warning"
          showIcon
          message="Resultado provisório"
          description={
            totalNaoInformadas > 0
              ? `Há ${totalNaoInformadas} aula(s) realizada(s) cuja chamada ainda não foi concluída.`
              : 'Há aulas realizadas cuja chamada ainda não foi concluída.'
          }
          className="responsavel-frequencia-card__alerta-provisorio"
        />
      )}

      <div className="responsavel-frequencia-card__contadores">
        <Text>{totalAulasRealizadas} aula(s) realizada(s)</Text>
        <Text>{totalPresentes} presente(s)</Text>
        <Text>{totalAusentes} ausência(s)</Text>
        <Text>{totalJustificadas} falta(s) justificada(s)</Text>
        {totalNaoInformadas > 0 && <Text>{totalNaoInformadas} sem chamada informada</Text>}
      </div>

      <Button
        type="primary"
        block
        onClick={() => onVerDetalhes(matriculaId)}
        className="responsavel-frequencia-card__botao"
      >
        Ver detalhes
      </Button>
    </Card>
  );
};

export default ResponsavelFrequenciaCard;
